import { render, staticRenderFns } from "./dev-warning-stat.vue?vue&type=template&id=54fca073&scoped=true"
import script from "./dev-warning-stat.vue?vue&type=script&lang=js"
export * from "./dev-warning-stat.vue?vue&type=script&lang=js"
import style0 from "./dev-warning-stat.vue?vue&type=style&index=0&id=54fca073&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fca073",
  null
  
)

export default component.exports